(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .filter('formatRole', formatRole);

    function formatRole() {
        return formatRoleFilter;

        function formatRoleFilter (input) {
        	if (input !== null && input.ruolo !== undefined) {
        		var arr = [];
        		if (input.ruolo) arr.push(input.ruolo);
        		if (input.macroCategoria) arr.push(input.macroCategoria);
        		if (input.categoria) arr.push(input.categoria);
        		if (input.sottoCategoria) arr.push(input.sottoCategoria);
        		if (input.statoSpecifico) arr.push(input.statoSpecifico);
        		return arr.join("-");
            }
            return input;
        }
    }
})();
